'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Exception = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _navLink = require('../navLink');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * data = {
 *  title,
 *  desc,
 *  img
 * }
 */
/* eslint-disable react/prop-types */
var Exception = function Exception(_ref) {
  var className = _ref.className,
      data = _ref.data,
      links = _ref.links,
      rest = _objectWithoutProperties(_ref, ['className', 'data', 'links']);

  return _react2.default.createElement(
    'div',
    _extends({ className: 'j-com-exception ' + className }, rest),
    _react2.default.createElement(
      'div',
      { className: 'imgBlock' },
      _react2.default.createElement('div', {
        className: 'imgEle',
        style: { backgroundImage: 'url(' + data.img + ')' }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(
        'h1',
        null,
        data.title
      ),
      _react2.default.createElement(
        'div',
        { className: 'desc' },
        data.desc
      ),
      links && _react2.default.createElement(
        'div',
        { className: 'links' },
        _react2.default.createElement(_navLink.NavLink, { links: links })
      )
    )
  );
};
exports.Exception = Exception;


//////////////////
// WEBPACK FOOTER
// ./src/components/exception/index.jsx
// module id = 35
// module chunks = 0